import { combineReducers } from 'redux'
import navState from './navState'
import searchText from './searchText'
import downList from './downList'
export default combineReducers({
  navState,
  searchText,
  downList
})